import { IToggle } from 'unleash-proxy-client';

import { AppState } from 'types/app';
import { FEATURE_MAFIA_AKAMAI } from 'constants/features';

export const selectFeature = (feature: string, state: AppState) => state.features?.[feature];

export const selectUnleashToggle = (feature: string, state: AppState): IToggle | undefined =>
  (state.unleash?.toggles || []).find((t: IToggle) => t.name === feature);

export const selectUnleashVariant = (feature: string, state: AppState) => selectUnleashToggle(feature, state)?.variant.payload?.value;

export const selectIsFeatureMafiaAkamai = (state: AppState) => selectFeature(FEATURE_MAFIA_AKAMAI, state);
